import { render } from "./page16.vue?vue&type=template&id=41025318&scoped=true"
import script from "./page16.vue?vue&type=script&lang=js"
export * from "./page16.vue?vue&type=script&lang=js"

import "./page16.vue?vue&type=style&index=0&id=41025318&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41025318"]])

export default __exports__